"use strict";

var _AlignCenterIcon = require("./components/AlignCenterIcon");

var _AlignCenterIcon2 = _interopRequireDefault(_AlignCenterIcon);

var _AlignLeftIcon = require("./components/AlignLeftIcon");

var _AlignLeftIcon2 = _interopRequireDefault(_AlignLeftIcon);

var _AlignRightIcon = require("./components/AlignRightIcon");

var _AlignRightIcon2 = _interopRequireDefault(_AlignRightIcon);

var _ArchiveIcon = require("./components/ArchiveIcon");

var _ArchiveIcon2 = _interopRequireDefault(_ArchiveIcon);

var _BackIcon = require("./components/BackIcon");

var _BackIcon2 = _interopRequireDefault(_BackIcon);

var _BillingIcon = require("./components/BillingIcon");

var _BillingIcon2 = _interopRequireDefault(_BillingIcon);

var _BlockQuoteIcon = require("./components/BlockQuoteIcon");

var _BlockQuoteIcon2 = _interopRequireDefault(_BlockQuoteIcon);

var _BoldIcon = require("./components/BoldIcon");

var _BoldIcon2 = _interopRequireDefault(_BoldIcon);

var _BulletedListIcon = require("./components/BulletedListIcon");

var _BulletedListIcon2 = _interopRequireDefault(_BulletedListIcon);

var _CheckboxIcon = require("./components/CheckboxIcon");

var _CheckboxIcon2 = _interopRequireDefault(_CheckboxIcon);

var _CheckmarkIcon = require("./components/CheckmarkIcon");

var _CheckmarkIcon2 = _interopRequireDefault(_CheckmarkIcon);

var _CloseIcon = require("./components/CloseIcon");

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _CodeIcon = require("./components/CodeIcon");

var _CodeIcon2 = _interopRequireDefault(_CodeIcon);

var _CollapsedIcon = require("./components/CollapsedIcon");

var _CollapsedIcon2 = _interopRequireDefault(_CollapsedIcon);

var _CollectionIcon = require("./components/CollectionIcon");

var _CollectionIcon2 = _interopRequireDefault(_CollectionIcon);

var _DocumentIcon = require("./components/DocumentIcon");

var _DocumentIcon2 = _interopRequireDefault(_DocumentIcon);

var _EditIcon = require("./components/EditIcon");

var _EditIcon2 = _interopRequireDefault(_EditIcon);

var _EmailIcon = require("./components/EmailIcon");

var _EmailIcon2 = _interopRequireDefault(_EmailIcon);

var _ExpandedIcon = require("./components/ExpandedIcon");

var _ExpandedIcon2 = _interopRequireDefault(_ExpandedIcon);

var _EyeIcon = require("./components/EyeIcon");

var _EyeIcon2 = _interopRequireDefault(_EyeIcon);

var _GoToIcon = require("./components/GoToIcon");

var _GoToIcon2 = _interopRequireDefault(_GoToIcon);

var _GroupIcon = require("./components/GroupIcon");

var _GroupIcon2 = _interopRequireDefault(_GroupIcon);

var _HashtagIcon = require("./components/HashtagIcon");

var _HashtagIcon2 = _interopRequireDefault(_HashtagIcon);

var _Heading1Icon = require("./components/Heading1Icon");

var _Heading1Icon2 = _interopRequireDefault(_Heading1Icon);

var _Heading2Icon = require("./components/Heading2Icon");

var _Heading2Icon2 = _interopRequireDefault(_Heading2Icon);

var _HomeIcon = require("./components/HomeIcon");

var _HomeIcon2 = _interopRequireDefault(_HomeIcon);

var _HorizontalRuleIcon = require("./components/HorizontalRuleIcon");

var _HorizontalRuleIcon2 = _interopRequireDefault(_HorizontalRuleIcon);

var _Icon = require("./components/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _ImageIcon = require("./components/ImageIcon");

var _ImageIcon2 = _interopRequireDefault(_ImageIcon);

var _InsertAboveIcon = require("./components/InsertAboveIcon");

var _InsertAboveIcon2 = _interopRequireDefault(_InsertAboveIcon);

var _InsertBelowIcon = require("./components/InsertBelowIcon");

var _InsertBelowIcon2 = _interopRequireDefault(_InsertBelowIcon);

var _InsertLeftIcon = require("./components/InsertLeftIcon");

var _InsertLeftIcon2 = _interopRequireDefault(_InsertLeftIcon);

var _InsertRightIcon = require("./components/InsertRightIcon");

var _InsertRightIcon2 = _interopRequireDefault(_InsertRightIcon);

var _ItalicIcon = require("./components/ItalicIcon");

var _ItalicIcon2 = _interopRequireDefault(_ItalicIcon);

var _JournalIcon = require("./components/JournalIcon");

var _JournalIcon2 = _interopRequireDefault(_JournalIcon);

var _KeyboardIcon = require("./components/KeyboardIcon");

var _KeyboardIcon2 = _interopRequireDefault(_KeyboardIcon);

var _LinkIcon = require("./components/LinkIcon");

var _LinkIcon2 = _interopRequireDefault(_LinkIcon);

var _MenuIcon = require("./components/MenuIcon");

var _MenuIcon2 = _interopRequireDefault(_MenuIcon);

var _MoonIcon = require("./components/MoonIcon");

var _MoonIcon2 = _interopRequireDefault(_MoonIcon);

var _MoreIcon = require("./components/MoreIcon");

var _MoreIcon2 = _interopRequireDefault(_MoreIcon);

var _NewDocumentIcon = require("./components/NewDocumentIcon");

var _NewDocumentIcon2 = _interopRequireDefault(_NewDocumentIcon);

var _NextIcon = require("./components/NextIcon");

var _NextIcon2 = _interopRequireDefault(_NextIcon);

var _OpenIcon = require("./components/OpenIcon");

var _OpenIcon2 = _interopRequireDefault(_OpenIcon);

var _OrderedListIcon = require("./components/OrderedListIcon");

var _OrderedListIcon2 = _interopRequireDefault(_OrderedListIcon);

var _PadlockIcon = require("./components/PadlockIcon");

var _PadlockIcon2 = _interopRequireDefault(_PadlockIcon);

var _PinIcon = require("./components/PinIcon");

var _PinIcon2 = _interopRequireDefault(_PinIcon);

var _PlusIcon = require("./components/PlusIcon");

var _PlusIcon2 = _interopRequireDefault(_PlusIcon);

var _PrivateCollectionIcon = require("./components/PrivateCollectionIcon");

var _PrivateCollectionIcon2 = _interopRequireDefault(_PrivateCollectionIcon);

var _ProfileIcon = require("./components/ProfileIcon");

var _ProfileIcon2 = _interopRequireDefault(_ProfileIcon);

var _SearchIcon = require("./components/SearchIcon");

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _SettingsIcon = require("./components/SettingsIcon");

var _SettingsIcon2 = _interopRequireDefault(_SettingsIcon);

var _StarredIcon = require("./components/StarredIcon");

var _StarredIcon2 = _interopRequireDefault(_StarredIcon);

var _StrikethroughIcon = require("./components/StrikethroughIcon");

var _StrikethroughIcon2 = _interopRequireDefault(_StrikethroughIcon);

var _TableIcon = require("./components/TableIcon");

var _TableIcon2 = _interopRequireDefault(_TableIcon);

var _TeamIcon = require("./components/TeamIcon");

var _TeamIcon2 = _interopRequireDefault(_TeamIcon);

var _TodoListIcon = require("./components/TodoListIcon");

var _TodoListIcon2 = _interopRequireDefault(_TodoListIcon);

var _TrashIcon = require("./components/TrashIcon");

var _TrashIcon2 = _interopRequireDefault(_TrashIcon);

var _UserIcon = require("./components/UserIcon");

var _UserIcon2 = _interopRequireDefault(_UserIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  AlignCenterIcon: _AlignCenterIcon2.default,
  AlignLeftIcon: _AlignLeftIcon2.default,
  AlignRightIcon: _AlignRightIcon2.default,
  ArchiveIcon: _ArchiveIcon2.default,
  BackIcon: _BackIcon2.default,
  BillingIcon: _BillingIcon2.default,
  BlockQuoteIcon: _BlockQuoteIcon2.default,
  BoldIcon: _BoldIcon2.default,
  BulletedListIcon: _BulletedListIcon2.default,
  CheckboxIcon: _CheckboxIcon2.default,
  CheckmarkIcon: _CheckmarkIcon2.default,
  CloseIcon: _CloseIcon2.default,
  CodeIcon: _CodeIcon2.default,
  CollapsedIcon: _CollapsedIcon2.default,
  CollectionIcon: _CollectionIcon2.default,
  DocumentIcon: _DocumentIcon2.default,
  EditIcon: _EditIcon2.default,
  EmailIcon: _EmailIcon2.default,
  ExpandedIcon: _ExpandedIcon2.default,
  EyeIcon: _EyeIcon2.default,
  GoToIcon: _GoToIcon2.default,
  GroupIcon: _GroupIcon2.default,
  HashtagIcon: _HashtagIcon2.default,
  Heading1Icon: _Heading1Icon2.default,
  Heading2Icon: _Heading2Icon2.default,
  HomeIcon: _HomeIcon2.default,
  HorizontalRuleIcon: _HorizontalRuleIcon2.default,
  Icon: _Icon2.default,
  ImageIcon: _ImageIcon2.default,
  InsertAboveIcon: _InsertAboveIcon2.default,
  InsertBelowIcon: _InsertBelowIcon2.default,
  InsertLeftIcon: _InsertLeftIcon2.default,
  InsertRightIcon: _InsertRightIcon2.default,
  ItalicIcon: _ItalicIcon2.default,
  JournalIcon: _JournalIcon2.default,
  KeyboardIcon: _KeyboardIcon2.default,
  LinkIcon: _LinkIcon2.default,
  MenuIcon: _MenuIcon2.default,
  MoonIcon: _MoonIcon2.default,
  MoreIcon: _MoreIcon2.default,
  NewDocumentIcon: _NewDocumentIcon2.default,
  NextIcon: _NextIcon2.default,
  OpenIcon: _OpenIcon2.default,
  OrderedListIcon: _OrderedListIcon2.default,
  PadlockIcon: _PadlockIcon2.default,
  PinIcon: _PinIcon2.default,
  PlusIcon: _PlusIcon2.default,
  PrivateCollectionIcon: _PrivateCollectionIcon2.default,
  ProfileIcon: _ProfileIcon2.default,
  SearchIcon: _SearchIcon2.default,
  SettingsIcon: _SettingsIcon2.default,
  StarredIcon: _StarredIcon2.default,
  StrikethroughIcon: _StrikethroughIcon2.default,
  TableIcon: _TableIcon2.default,
  TeamIcon: _TeamIcon2.default,
  TodoListIcon: _TodoListIcon2.default,
  TrashIcon: _TrashIcon2.default,
  UserIcon: _UserIcon2.default
};